<template>
  <div class="app flex-row align-items-center">
    <div class="container">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <form action="#" @submit.prevent="login">
                  <h1>Connexion</h1>
                  <p class="text-muted">Connectez-vous à votre compte</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" class="form-control" placeholder="Votre email" autocomplete="email" v-model="username" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input :type="class_password.type" class="form-control" placeholder="Votre mot de passe" autocomplete="current-password" v-model="password" style="width:40px;height:35px;"/>
                    <b-input-group-append>
                      <b-button variant="primary" @click.prevent="see()" style="width:40px;height:35px;"><i :class="class_password.icon"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="primary">Connexion</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0" @click="forgetPassword">Mot de passe oublié?</b-button>
                    </b-col>
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="background-color: #215aa9 !important;width:44%">
              <b-card-body class="text-center">
                <div>
                  <!--<h2>PosteOne</h2>-->
                  <h2><img src="img/logo.jpg" style="width:50%;"/></h2>
                  <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor #5cc3e4 incididunt ut labore et dolore magna aliqua.</p> -->
                  <!--<b-button variant="primary" class="active mt-3">Register Now!</b-button>-->
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
//import auth from '../../store/modules/auth'
export default {
  name: 'Login',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      username:'',
      password:'',
      errorMsg:'',
      class_password : {
        icon : "fa fa-eye",
        type : 'password',
        text:''
      }
    }
  },
  methods:{
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    see(){
        if (this.view_passord==false){
            this.class_password.icon ="fa fa-eye"
            this.class_password.type ="password"
            this.view_passord = true
        }else{
            this.class_password.icon ="fa fa-eye-slash"
            this.class_password.type ="text"
            this.view_passord = false
        }
    },
    login(){
      if(this.username.trim().length == 0 || this.password.trim().length == 0){
        return
      }
      this.$store.dispatch('auth/login_step_one',{
        username :this.username,
        password: this.password,
      })
      .then(response =>{
        this.$router.push({ name : 'SecretCode'})
      })
      .catch(error=>{
        console.log(error.response)
        this.response = error.response.data
        
        this.showAlert()
        return
      })
    },
    forgetPassword(){
       this.$router.push({name:'forgetPassword'})
    }
  }

}
</script>
